import fulltime, { FulltimeState } from './fulltimes/fulltime.store';

export interface CompanyJointComitteeState {
   fulltime?: FulltimeState;
}

const state: CompanyJointComitteeState = {};

const getters = {};

const mutations = {};

const actions = {};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
   modules: {
      fulltime,
   },
};
